<template>
  <div class="menu-container">
    <van-row>
      <van-col span="8">
        <router-link tag="div" to="/admin/order/list" class="grid-cell-container">
          <div class="grid-cell border-rightbottom">
            <div class="icons">
              <div class="icon-img">
                <span class="iconfont order-icon">&#xe61f;</span>
              </div>
              <div class="icon-desc">订单管理</div>
            </div>
          </div>
        </router-link>
      </van-col>
      <van-col span="8">
        <router-link tag="div" to="/admin/merch" class="grid-cell-container">
          <div class="grid-cell border-rightbottom">
            <div class="icons">
              <div class="icon-img">
                <span class="iconfont merch-icon">&#xe7a8;</span>
              </div>
              <div class="icon-desc">门店管理</div>
            </div>
          </div>
        </router-link>
      </van-col>
      <van-col span="8">
        <router-link tag="div" to="/admin/spec" class="grid-cell-container">
          <div class="grid-cell border-rightbottom">
            <div class="icons">
              <div class="icon-img">
                <span class="iconfont spec-icon">&#xe65d;</span>
              </div>
              <div class="icon-desc">规格管理</div>
            </div>
          </div>
        </router-link>
      </van-col>
      <van-col span="8">
        <div class="grid-cell border-rightbottom grid-cell-container">
          <div class="icons">
            <div class="icon-img">
              <span class="iconfont qidai-icon">&#xe653;</span>
            </div>
            <div class="icon-desc">敬情期待</div>
          </div>
        </div>
      </van-col>
      <van-col span="8">
        <div class="grid-cell border-rightbottom grid-cell-container">
          <div class="icons">
            <div class="icon-img">
              <span class="iconfont qidai-icon">&#xe653;</span>
            </div>
            <div class="icon-desc">敬情期待</div>
          </div>
        </div>
      </van-col>
      <van-col span="8">
        <div class="grid-cell border-rightbottom grid-cell-container">
          <div class="icons">
            <div class="icon-img">
              <span class="iconfont qidai-icon">&#xe653;</span>
            </div>
            <div class="icon-desc">敬情期待</div>
          </div>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      complete: false
    };
  }
};
</script>

<style lang="stylus" scoped>
@import '~@style/varibles.styl';

.menu-container {
  padding: 0;
  background-color: #fff;

  .border-rightbottom, .border-right, .border-bottom {
    &:before, &:after {
      border-color: #ccc;
    }
  }

  .grid-cell {
    height: 0;
    background-color: #fff;
    overflow: hidden;
    padding-bottom: 100%;
    position: relative;

    .icons {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      top: 0;
      left: 0;
      line-height: 1.6;

      .icon-img span {
        font-size: 0.7rem;
      }

      .icon-img .order-icon {
        color: #e83b56;
      }

      .icon-img .merch-icon {
        color: #3b98e8;
      }

      .icon-img .spec-icon {
        color: #8d98e8;
      }

      .icon-img .qidai-icon {
        color: #666;
      }

      .icon-img .category-icon {
        color: #f60;
      }

      .icon-desc {
        color: #333;
      }
    }
  }

  .menu-gutter {
    padding: 0.2rem;
  }
}
</style>
